// src/components/co-ownership/CoOwnershipProcess.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { renderIcon } from '@dopomogai/utils';
import { ArrowRight } from 'lucide-react';

export const CoOwnershipProcess: React.FC = () => {
  const { t } = useTranslation('co_ownership');
  const processData = t('process', { returnObjects: true }) as any;

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-16">{processData.headline}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processData.steps.map((step: any, index: number) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="flex flex-col text-center items-center"
            >
              <div className="relative mb-6">
                <div className="bg-slate-100 w-20 h-20 rounded-full border-2 border-black flex items-center justify-center">
                  {renderIcon(step.icon, { size: 32, className: 'text-gray-800' })}
                </div>
                {index < processData.steps.length - 1 && (
                  <ArrowRight size={24} className="hidden lg:block absolute top-1/2 -translate-y-1/2 -right-16 text-slate-300" />
                )}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{step.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

